define.alias("shared/components/shared/upgrade/bonus-features", "settings/components/shared/upgrade/bonus-features");